export const getListTicketsParams = (route) => ({
    my_tickets: route.query.my_tickets,
    triage: route.query.triage,
    department: route.query.department,
    per_page: route.query.per_page || -1,
    company_id: route.params.customerId,
    status: route.params.customerId ? 'all' : null,
    sorters: [
        {
            selector: 'status',
            desc: false,
        }
    ],
    query: {
        ticket: [
            'id',
            'title',
            'description',
            'status',
            'number',
            'company',
            'type',
            'department',
            'updated_at_for_human',
            'priority',
            'description_format',
            'staff_only',
            'status_id',
        ],
        ticket_type: [
            'title',
            'id',
            'department_id',
        ],
        ticket_department: [
            'title',
            'id',
        ],
        ticket_priority: [
            'id',
            'color',
            'title',
        ],
        company: [
            'id',
            'title_with_name',
        ],
        ticket_status: [
            'id',
            'title',
        ]
    },
})
